const configService = {
    apiUrl: 'https://www.congresoqroo.gob.mx/api/datos-abiertos/'
}

export default configService



// WEBPACK FOOTER //
// ./src/services/config.js